import { Route, Routes } from "react-router";
import { Home } from "./pages/home";
import { Landing } from "./pages/landing";
import { Login } from "./pages/authenticatoin/login";
import { Dashboard } from "./pages/dashboard";
import { Signup } from "./pages/authenticatoin/signup";
import TraderProtection from "./routesProtection/TraderProtection";
import { Snackbars } from "./components/Snackbars";
import { useAuth } from "./providers/AuthenticationProvider";
import Loading from "./components/Loading";
import OnlyTrader from "./routesProtection/OnlyTrader";
import { Trader } from "./pages/trader/Trader";
import { AdminPage } from "./pages/admin/AdminPage";
import OnlyAdmin from "./routesProtection/OnlyAdmin";
import { Terms } from "./pages/Terms";
import { Privacy } from "./pages/Privacy";
import OnlyAffiliate from "./routesProtection/OnlyAffiliate";
import { Affiliate } from "./pages/affiliate/Affiliate";
import { Products } from "./pages/products";
import { FirstTimePurchaseComplete } from "./pages/user/FirstTimePurchaseComplete";
import { UserDashboard } from "./pages/user/UserDashboard";
import HideAppBar from "./components/testNav";
import { GoAffiliate } from "./pages/goAffiliate";

const Root = () => {
	const { authInitialized, profileInitialized } = useAuth();
	if (!authInitialized || !profileInitialized) return <Loading />;
	return (
		<>
			<Snackbars />
			<HideAppBar />

			<Routes>
				<Route
					path="/home"
					element={
						<>
							<Home />
						</>
					}
				/>
				<Route
					path="/"
					element={
						<>
							<Landing />
						</>
					}
				/>

				<Route
					path="/products"
					element={
						<>
							<Products />
						</>
					}
				/>
				<Route
					path="/privacy-policy"
					element={
						<>
							<Privacy />
						</>
					}
				/>

				<Route
					path="/terms-condition"
					element={
						<>
							<Terms />
						</>
					}
				/>
				<Route
					path="/terms-of-use"
					element={
						<>
							<Terms />
						</>
					}
				/>

				<Route
					path="/login"
					element={
						<>
							<Login />
						</>
					}
				/>
				<Route
					path="/signup"
					element={
						<>
							<Signup />
						</>
					}
				/>
				<Route path="/reserved" element={<TraderProtection />}>
					<Route
						path="/reserved/dashboard"
						element={
							<>
								<UserDashboard />
							</>
						}
					/>
					<Route
						path="/reserved/become-trader"
						element={
							<>
								<Dashboard />
							</>
						}
					/>
					<Route
						path="/reserved/become-affiliate"
						element={
							<>
								<GoAffiliate />
							</>
						}
					/>
					
					<Route
						path="/reserved/firstPaymentCompleted"
						element={
							<>
								<FirstTimePurchaseComplete />
							</>
						}
					/>
				</Route>

				<Route path="/trader" element={<OnlyTrader />}>
					<Route
						path="/trader/ExpertAdvisor"
						element={
							<>
								<Dashboard />
							</>
						}
					/>
					<Route
						path="/trader/profile"
						element={
							<>
								<Trader />
							</>
						}
					/>
				</Route>
				<Route path="/onlyAdmin" element={<OnlyAdmin />}>
					<Route
						path="/onlyAdmin/"
						element={
							<>
								<AdminPage />
							</>
						}
					/>
				</Route>
				<Route path="/affiliate" element={<OnlyAffiliate />}>
					<Route
						path="/affiliate/dashboard"
						element={
							<>
								<Affiliate />
							</>
						}
					/>
				</Route>
			</Routes>
		</>
	);
};

export default Root;
